import { Modal } from "react-bootstrap";

const SEC = { fontSize: 11, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "#16342a", background: "#eef1e7", borderRadius: 6, padding: "5px 11px", margin: "16px 0 8px" };
const FILA = { display: "flex", justifyContent: "space-between", gap: 12, padding: "5px 0", borderBottom: "1px solid #f1f3f5", fontSize: 13 };
const LBL = { color: "#6c757d", flexShrink: 0 };
const VAL = { fontWeight: 600, textAlign: "right" };

function Dato({ label, valor }) {
  if (valor === undefined || valor === null || valor === "") return null;
  return (
    <div style={FILA}>
      <span style={LBL}>{label}</span>
      <span style={VAL}>{Array.isArray(valor) ? valor.join(", ") : String(valor)}</span>
    </div>
  );
}

export default function VerVisitaModal({ show, onClose, visita }) {
  if (!visita) return null;
  const v = visita;
  const esEfectiva = v.estado_vivienda === "Efectiva";

  return (
    <Modal show={show} onHide={onClose} centered scrollable size="lg">
      <Modal.Header closeButton style={{ background: "linear-gradient(135deg, #16342a, #2d6a4f)", color: "#fff" }}>
        <Modal.Title style={{ fontSize: "1rem" }}>
          👁 {v.codigo_vivienda} {v.numero_visita > 1 ? `— Intento #${v.numero_visita}` : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={SEC}>🪪 Identificación de la visita</div>
        <Dato label="Líder de la BAC" valor={v.lider_bac} />
        <Dato label="Entrevistador" valor={v.entrevistador} />
        <Dato label="Fecha de registro" valor={v.createdAt?.split("T")[0]} />

        <div style={SEC}>📍 Ubicación</div>
        <Dato label="Territorio" valor={v.territorio} />
        <Dato label="Comunidad" valor={v.comunidad} />
        <Dato label="Dirección" valor={v.direccion} />
        <Dato label="Coordenadas" valor={v.lat && v.lng ? `${v.lat}, ${v.lng}` : null} />

        <div style={SEC}>🏠 Vivienda</div>
        <Dato label="Tipo de vivienda" valor={v.tipo_fisico_vivienda} />
        <Dato label="Estado de la visita" valor={v.estado_vivienda} />
        {v.estado_vivienda === "No efectiva" && <Dato label="Motivo" valor={v.motivo_no_efectiva} />}
        <Dato label="Revisita sugerida" valor={v.fecha_revisita_sugerida} />
        <Dato label="Nota de revisita" valor={v.nota_revisita} />

        {v.foto_url && (
          <>
            <div style={SEC}>📷 Fotografía</div>
            <img src={v.foto_url} alt="Vivienda" style={{ width: "100%", maxHeight: 260, objectFit: "cover", borderRadius: 8 }} />
          </>
        )}

        {esEfectiva && (
          <>
            <div style={SEC}>🧑 Datos de contacto</div>
            <Dato label="Nombres y apellidos" valor={v.nombre_entrevistado} />
            <Dato label="Tipo de documento" valor={v.tipo_documento} />
            <Dato label="N° documento" valor={v.documento_identificacion} />
            <Dato label="Género" valor={v.genero} />
            <Dato label="Teléfono" valor={v.telefono} />
            <Dato label="EPS" valor={v.eps === "Otro" ? v.otra_eps : v.eps} />
            <Dato label="Régimen de afiliación" valor={v.regimen_afiliacion} />
            <Dato label="Grupo poblacional" valor={v.grupo_poblacional} />
            <Dato label="Pertenencia étnica" valor={v.pertenencia_etnica} />

            <div style={SEC}>👥 Composición del hogar</div>
            <Dato label="N° personas entrevistadas" valor={v.numero_personas_entrevistadas} />
            <Dato label="N° personas en la vivienda" valor={v.numero_personas_vivienda} />
            {Array.isArray(v.integrantes) && v.integrantes.length > 0 && (
              <div style={{ marginTop: 6 }}>
                {v.integrantes.map((p, i) => (
                  <div key={i} style={{ fontSize: 12.5, padding: "4px 10px", background: "#f5f6f0", borderRadius: 6, marginBottom: 4 }}>
                    <strong>{p.nombre}</strong> — {p.edad} {p.unidad}
                  </div>
                ))}
              </div>
            )}

            <div style={SEC}>🚨 EISP</div>
            <Dato label="¿EISP encontrado?" valor={v.eisp_encontrado} />
            <Dato label="¿Cuál o cuáles?" valor={v.eisp_cual} />
            <Dato label="Síntomas observados" valor={v.sintomas_observados} />

            {Array.isArray(v.contactos) && v.contactos.length > 0 && (
              <>
                <div style={SEC}>📇 Contactos</div>
                {v.contactos.map((c, i) => (
                  <div key={i} style={{ fontSize: 12.5, padding: "8px 10px", background: "#f5f6f0", borderRadius: 8, marginBottom: 6 }}>
                    <div><strong>{c.nombre_apellidos}</strong> — {c.tipo_identificacion} {c.documento_identidad}</div>
                    {c.direccion && <div className="text-muted">{c.direccion}</div>}
                    {c.eapb && <div>EAPB: {c.eapb}</div>}
                    {(c.grupo_poblacional || []).length > 0 && <div>Grupo poblacional: {c.grupo_poblacional.join(", ")}</div>}
                    {(c.pertenencia_etnica || []).length > 0 && <div>Enfoque diferencial: {c.pertenencia_etnica.join(", ")}</div>}
                    {c.etnia_indigena && <div>Etnia: {c.etnia_indigena}</div>}
                    {c.contacto_caso_sospechoso === "SI" && (
                      <span className="badge bg-danger mt-1">caso sospechoso/probable</span>
                    )}
                    {c.observacion && <div className="text-muted mt-1">{c.observacion}</div>}
                  </div>
                ))}
              </>
            )}
          </>
        )}

        {v.estado_vivienda === "Efectiva" && (v.sabe_vacunacion || v.conoce_personajes_vacunacion || v.medios_informacion) && (
          <>
            <div style={SEC}>📣 Comunicación</div>
            <Dato label="¿Cómo se entera de la información de la Secretaría?" valor={(() => {
              const m = v.medios_informacion;
              const lista = Array.isArray(m) ? m : (() => { try { const x = JSON.parse(m || "[]"); return Array.isArray(x) ? x : []; } catch { return []; } })();
              return lista.length ? lista.join(", ") : null;
            })()} />
            <Dato label="¿Sabe algo sobre vacunación?" valor={v.sabe_vacunacion} />
            <Dato label="¿Conoce los personajes (muñequitos) de la vacunación?" valor={v.conoce_personajes_vacunacion} />
          </>
        )}

        <div style={SEC}>📝 Observaciones</div>
        <p style={{ fontSize: 13, whiteSpace: "pre-wrap" }}>{v.observaciones || <span className="text-muted">Sin observaciones</span>}</p>
      </Modal.Body>
    </Modal>
  );
}